import type { TFunction } from "i18next";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import type { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { namePerType } from "../../FacilityManager/Components/Toolbars/InfoSidebar/AssignBox/AssignBox";

export function resolveScheduleEventPlaceName(
  schedule: BookingScheduleInterface,
  t: TFunction
): string {
  if (schedule.locationName === "Mobile Working") {
    return t("Mobile Working");
  }

  if (schedule.bookingInventory?.name === "Mobile Working") {
    return t("Mobile Working");
  }

  if (schedule.bookingType === BookingType.VEHICLE && schedule.vehicleInfo?.name) {
    return schedule.vehicleInfo.name;
  }

  if (schedule.bookingInventory?.name) {
    return schedule.bookingInventory.name;
  }

  if (schedule.bookingType === BookingType.RESOURCE && schedule.workplaceUid) {
    return schedule.workplaceUid;
  }

  return t(namePerType(schedule.bookingType, t));
}
